<p-card class="w-full h-full">
  <div class="pb-2 w-full flex justify-end">
    <button
      pButton
      pRipple
      type="button"
      label="{{ 'menu.next' | translate }}"
      [routerLink]="['../2']"
      [disabled]="(currentSelectedBauteile$ | async) === 0"
    ></button>
  </div>
  @if (bauteileWithReports$ | async; as bauteile) {
    <div
      class="w-full mx-auto h-full"
      >
      @if ((partsLoading$ | async) === false) {
        <partikelart-multi-export-part-table
          [parts]="bauteile"
          class="h-full"
          >
        </partikelart-multi-export-part-table>
      } @else {
        <div class="d-flex justify-content-center">
          <div class="loader">{{ "loading" | translate }}...</div>
        </div>
      }
    </div>
  }
  <div class="flex w-full justify-between pb-2" style="margin-top: 4rem"></div>
</p-card>
